import React from 'react';
import { createContext } from 'react';

export interface ContextState {
	ref: React.RefObject<HTMLDivElement>;
}

export const SidebarContext = createContext<ContextState>({} as ContextState);

export const useSidebar = () => React.useContext(SidebarContext);
